<template>
  <div class="page-amount-info">
    <!-- 证券现金 -->
    <el-col :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
            class="p-left"
            v-if="stockCashList.length">
      <account-item :accountList="stockCashList"
                    :selectItem="selectCashItem"
                    :num="stockCashNum"
                    typeKey="stockCashList"
                    @changeHandle="changeHandle"></account-item>
    </el-col>
    <!-- 证券保证金 -->
    <el-col :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
            class="p-left"
            v-if="stockMarginList.length">
      <account-item :accountList="stockMarginList"
                    :selectItem="selectMarginItem"
                    :num="stockMarginNum"
                    typeKey="stockMarginList"
                    @changeHandle="changeHandle"></account-item>
    </el-col>
    <!-- 期货 -->
    <el-col :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
            class="p-left"
            v-if="futuresList.length">
      <account-item :accountList="futuresList"
                    :selectItem="selectfuturesItem"
                    :num="futuresNum"
                    typeKey="futuresList"
                    @changeHandle="changeHandle"></account-item>
    </el-col>
    <!-- 其他 -->
    <el-col :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
            class="p-left"
            v-for="(item, key) in otherAccountInfo"
            :key="key">
      <el-row>
        <div class="card-base card-shadow--small home-form"
             :class="{'account-info': accountInfoClass}">
          <h2 class="account-info-title">
            <span>{{$t('tradeAccountType.'+item.tradeAccountType)}}</span>

            <el-tooltip v-if="item.isDormant" popper-class="account-tip" effect="dark"  :content="$t('accountInfo.accountDormant', {accountNumber: item.tradeAccountNumber})" placement="top-start" >
              <span class="what-dormant" >?</span>
            </el-tooltip>
            <span class="account-status" v-if="item.isDormant ">{{$t('common.dormant ')}}</span>
          </h2>
          <el-row class="flex-row">
            <el-col :span="12"
                    class="left">
              {{$t('home.accountNo')}}
            </el-col>
            <el-col :span="12"
                    class="right">
              {{item.tradeAccountNumber}}
            </el-col>
          </el-row>
          <div>
            <div v-if="(item.tradeAccountType ==='FUTURES_MARGIN' || item.tradeAccountType ==='FUTURES_DAYTRADING_MARGIN') && (item.moneyList && item.moneyList.length)"
                 class="text-center money">
              <div class="balance yesterday-balance"
                   v-for="(el, elIndex) in item.moneyList"
                   :key="elIndex">
                <div class="balance-title ">{{el.amountDescribe}}</div>
                <div class="curBalance ">
                  {{ isNaN(el.totalBalance) ? el.totalBalance : financial(el.totalBalance, el.currency)}}</div>
              </div>
            </div>

            <div v-else-if="item.tradeAccountType =='INTERACTIVE_BROKER_INTEGRATED_MARGIN'">
            </div>

            <div v-else
                 class="text-center money"
                 v-show="item.moneyList && item.moneyList.length">
              <div class="balance"
                   v-for="(el, elIndex) in item.moneyList"
                   :key="elIndex">
                <div class="balance-title">{{el.amountDescribe}}</div>
                <div class="curBalance">
                  {{isNaN(el.totalBalance) ? el.totalBalance : financial(el.totalBalance, el.currency)}}</div>
              </div>
            </div>
          </div>

          <div>
            <el-row class="flex-row row-bottom">
              <el-col :span="12"
                      class="left">
                {{$t('home.currency')}}
              </el-col>
              <el-col :span="12"
                      class="right">
                {{item.base_currency}}
              </el-col>
            </el-row>
            <el-row class="flex-row row-bottom">
              <el-col :span="12"
                      class="left">
                {{$t('home.enabled')}}
              </el-col>
              <el-col :span="12"
                      class="right">
                <span v-if="item.status === 'STOP'">{{$t('home.enabled_false')}}</span>
                <span v-else-if="item.status === 'OPEN'">{{$t('home.enabled_true')}}</span>
                <span v-else-if="item.status === 'CLOSE'">{{$t('home.enabled_close')}}</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-row>
    </el-col>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import tradeRequest from '@/api/v2/trade'
import accountItem from './accountItem.vue'

export default {
  components: {
    accountItem
  },
  data() {
    return {
      accountInfoClass: true,
      accountInfo: [],
      accountInfoObj: {},
      stockCashNum: '',
      stockMarginNum: '',
      futuresNum: '',
      stockCashList: [],
      stockMarginList: [],
      futuresList: [],
      otherAccountInfo: [],
      selectCashItem: {},
      selectMarginItem: {},
      selectfuturesItem: {},
      accountMap: {
        stockCashList: 'selectCashItem',
        stockMarginList: 'selectMarginItem',
        futuresList: 'selectfuturesItem'
      }
    }
  },
  computed: {
    ...mapGetters(['getAllAccountInfo']),
    ...mapState(['filterSPTradingAccountList', 'userInfo'])
  },
  created() {
    let arr = []
    // SP 隐藏期货账户
    if (this.userInfo.isSPAccount === 'Y') {
      arr = this.filterSPTradingAccountList || []
    } else {
      arr = this.getAllAccountInfo.filter(item => {
      return ['OPEN', 'STOP'].includes(item.status)
    })
    }
    arr = arr.map(item => {
      return {
        tradeAccountNumber: item.tradeAccountNumber,
        tradeAccountType: item.tradeAccountType,
        status: item.status,
        base_currency: this.$t('home.loadingData'),
        type: item.type
      }
    })
    this.initData(arr)
    this.getAccountInfo()
  },
  methods: {
    initData(list) {
      let obj = {}
        this.accountInfo = list.map(item => {
          // item.isDormant = true
          item.moneyList &&
            item.moneyList.map(val => {
              item.base_currency = val.currency
            })
          obj[item.tradeAccountType] = obj[item.tradeAccountType] || []
          obj[item.tradeAccountType].push(item)
          return {
            ...item,
            base_currency:
              item.base_currency || '--'
          }
        })
        this.otherAccountInfo = this.accountInfo.filter(item => {
          return ![
            'SECURITIES_MARGIN',
            'SECURITIES_CASH',
            'FUTURES_MARGIN',
            'VA'
          ].includes(item.tradeAccountType)
        })
        for (let key in obj) {
          obj[key].moneyList &&
            obj[key].moneyList.map(val => {
              obj[key].base_currency =
                val.currency || '--'
            })
        }
        // 证券现金
        this.stockCashList =
          this.accountInfo.filter(item => {
            return item.tradeAccountType === 'SECURITIES_CASH'
          }) || []
        this.stockCashNum = this.stockCashList[0] && this.stockCashList[0].tradeAccountNumber
        this.selectCashItem = this.stockCashList[0]
        // 证券保证金
        this.stockMarginList =
          this.accountInfo.filter(item => {
            return item.tradeAccountType === 'SECURITIES_MARGIN'
          }) || []
        this.stockMarginNum = this.stockMarginList[0] && this.stockMarginList[0].tradeAccountNumber
        this.selectMarginItem = this.stockMarginList[0]
        // 期货
        this.futuresList =
          this.accountInfo.filter(item => {
            return item.tradeAccountType === 'FUTURES_MARGIN'
          }) || []
        this.futuresNum = this.futuresList[0] && this.futuresList[0].tradeAccountNumber
        this.selectfuturesItem = this.futuresList[0]
    },
    // 获取已开通和停用的交易账户
    async getAccountInfo() {
      // SP 隐藏期货账户
      let res = await tradeRequest.getAccountInfo()
      if (res.code && res.code === 200) {
        if (this.userInfo.isSPAccount === 'Y') {
          let arr = res.data.filter((item) => {
            return item.type !== 'FUTURES'
          })
          this.initData(arr)
        } else {
          this.initData(res.data)
        }
      }
    },
    financial(x, currency) {
      let amount = this.Util.formatCurrency(x)
      return `${currency} ${amount}`
    },
    changeHandle(val, key) {
      this.accountMap[key] = this[key].find(item => {
        return item.tradeAccountNumber === val
      })
      if (key === 'stockCashList') {
        this.$set(this, `selectCashItem`, this.accountMap[key])
      } else if (key === 'stockMarginList') {
        this.$set(this, `selectMarginItem`, this.accountMap[key])
      } else {
        this.$set(this, `selectfuturesItem`, this.accountMap[key])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-amount-info {
  min-height: 500px;
  .p-left {
    padding-left: 0 !important;
  }
  .account-info {
    height: 440px !important;
  }
  .box-bod {
    box-sizing: border-box !important;
  }
  .flex-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .row-bottom {
    padding-bottom: 16px;
    border-bottom: 1px solid #e2e2e2;
  }
  .pt-20 {
    padding-top: 20px;
  }
  .pb-20 {
    padding-bottom: 20px;
  }
  .pt-10 {
    padding-top: 10px;
  }
  .pb-10 {
    padding-bottom: 16px;
  }
  .p-20 {
    padding: 20px !important;
  }
  .p-10 {
    padding: 10px;
  }
  .mt-30 {
    margin-top: 30px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }

  .fx {
    display: flex;
  }
  hr {
    border: 2px solid #eee;
    margin: 20px 0;
  }
  .el-select {
    width: 100%;
  }
  .text-orange {
    color: #fec000;
  }
  .account-info {
    margin-top: 30px;
    padding: 30px;
  }
  .b-b1 {
    border-bottom: 1px solid #ebebeb;
  }
  .left {
    font-family: Muli-Regular;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0.13px;
  }
  .right {
    font-family: Muli-Bold;
    font-size: 16px;
    color: #24282d;
    letter-spacing: 0.14px;
    text-align: right;
  }
  .account-info-title {
    font-family: Muli-Bold;
    font-size: 18px !important;
    color: #182a54 !important;
    letter-spacing: 0.22px;
    border-bottom: 3px solid #ebebeb;
    padding: 10px 5px 20px;
  }
  .account-status{
    margin-left: 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #24282D;
    background: #F3F4F6;
    padding: 5px 10px;
    border-radius: 5px;
  }
  .what-dormant{
  margin-left: 10px;
  }
  .money {
    border: 10px solid #eee;
    margin-bottom: 22px;
    // padding: 15px 0;
    .balance {
      border-bottom: 6px solid #eee;
      padding: 15px 0;
      &:last-of-type {
        border-bottom: 0;
      }
    }
    .balance-title {
      font-family: Muli-Bold;
      font-size: 12px;
      color: #666666;
      text-align: center;
    }
    .curBalance {
      font-family: Muli-Bold;
      font-size: 22px;
      color: #24282d;
      letter-spacing: 0.27px;
      text-align: center;
    }
  }

  .other-info {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    .label {
      color: #666;
    }
  }
  .on-account-number {
    text-align: center;
    background: #fff;
    padding-bottom: 200px;
    margin-top: 20px;
    h2 {
      padding: 40px 0;
      font-weight: normal;
    }
    img {
      border: 1px solid #e2e2e2;
      margin: 0 20px;
      display: inline-block;
    }
  }
  @media (max-width: 768px) {
    .p-left {
      padding-right: 0 !important;
    }
    .layout-container .container .view {
      max-width: 100%;
      padding: 0;
      margin: 0;
    }
    .box-bod {
      margin: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .select-trading-account {
      margin-bottom: 0;
    }
    .m-0 {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
  .yesterday-balance {
    height: 153px !important;
    line-height: 50px !important;
  }
}
</style>
